module.exports = require("three-spritetext");